import { useFormContext, useController } from 'react-hook-form';
import { Flex, Typography, Radio, RadioGroup } from '@creditas-ui/react';
import { Messages } from '~/components/Messages';
import { useFieldEvents } from '~/utils/events/field-events';
import type { JSX } from 'react';
import type { FieldRadioSchema } from '~/shared/domain/models';

export type FieldRadioProps = {
  data: FieldRadioSchema;
};

type Component = (props: FieldRadioProps) => JSX.Element;

export const FieldRadio: Component = ({ data }) => {
  const { control } = useFormContext();

  const { name, label, defaultValue, disabled, messages } = data;
  const { handleOnChange } = useFieldEvents();

  const {
    field,
    formState: { errors },
  } = useController({
    name,
    control,
  });

  return (
    <Flex flexDirection="column">
      {label && (
        <Typography variant="bodyMdRegular" component="label">
          {label}:
        </Typography>
      )}
      <RadioGroup
        component={Flex}
        spaceY="8px"
        flexDirection="column"
        value={defaultValue}
        onChange={(value: string) => {
          field.onChange(value);
          handleOnChange({ element_name: name, element_value: value, field_type: 'radio' });
        }}
      >
        {data.options.map((option) => (
          <Radio
            key={option.value}
            id={option.value}
            disabled={disabled}
            label={option.label}
            value={option.value}
          />
        ))}
      </RadioGroup>

      <Messages messages={messages} errors={errors} name={name} />
    </Flex>
  );
};
